import { CloudUpload } from "@mui/icons-material";
import { CircularProgress, Input } from "@mui/material";
import React, { useCallback, useMemo, useRef, useState } from "react";
import {
    StyledGreyedTypography,
    StyledIconBox,
    StyledNormalTypography,
    StyledSpinnerBox,
    StyledUploadAreaBox,
    StyledUploadAreaContainerBox
} from "./BannerFileUploadArea.styled";

interface BannerFileUploadAreaProps {
    onFileSelect: (file: File) => void;
    isLoading?: boolean;
}

export const BannerFileUploadArea: React.FC<BannerFileUploadAreaProps> = ({ onFileSelect, isLoading = false }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleClick = () => {
        if (!isLoading && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            onFileSelect(event.target.files[0]);
        }
    };

    const handleDragOver = useCallback((e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }, []);

    const handleDragLeave = useCallback((e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    }, []);

    const handleDrop = useCallback((e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            if (file.type.startsWith('image/')) {
                onFileSelect(file);
            } else {
                alert("Por favor, selecione apenas arquivos de imagem.");
            }
        }
    }, [onFileSelect]);

    return (
        <StyledUploadAreaContainerBox hide={isLoading}>
            <StyledUploadAreaBox
                hide={isLoading}
                onClick={handleClick}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                sx={{
                    borderColor: isDragging ? 'primary.main' : undefined,
                    backgroundColor: isDragging ? 'rgba(25, 118, 210, 0.12)' : undefined,
                }}
            >
                <StyledSpinnerBox hide={!isLoading}>
                    <CircularProgress variant="indeterminate" />
                </StyledSpinnerBox>

                <StyledIconBox hide={isLoading}>
                    <CloudUpload sx={{ fontSize: 64 }} />
                </StyledIconBox>

                <StyledNormalTypography hide={isLoading} variant="h6" fontWeight="bold" gutterBottom>
                    Clique ou arraste a imagem aqui
                </StyledNormalTypography>

                <StyledGreyedTypography hide={isLoading}>
                    Suporta: JPG, PNG, WEBP
                </StyledGreyedTypography>

                <Input
                    type="file"
                    inputRef={fileInputRef}
                    onChange={handleFileChange}
                    inputProps={{ accept: "image/*" }}
                    sx={{ display: 'none' }}
                />
            </StyledUploadAreaBox>
        </StyledUploadAreaContainerBox>
    );
};
